import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function cancelServiceBooking(id: string) {
  return getSMPBackendAPIAdmin().serviceBookingsControllerCancelV1(id);
}

export function useCancelServiceBooking() {
  return useMutation({ mutationFn: cancelServiceBooking });
}
